module.exports = __webpack_public_path__ + "img/tor1.d2b68130.jpg";